var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Experience"},[(!_vm.$root.isDesk)?_c('Section'):_vm._e(),(_vm.$root.isDesk)?_c('Desktop'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }